import AddPropertyConstants from '../../constants/AddPropertyConstants';

import type { CurrentPropertyProps } from '../../model/CurrentProperty';

export type ListingReducerProps = Partial<CurrentPropertyProps> & {
  isRoomForRent: string;
  address: string;
  duplicateAccountListingAlias?: string;
  propertyType: string;
};

const listing = (
  state: ListingReducerProps,
  action: { type: keyof ListingReducerProps | typeof AddPropertyConstants.UPDATE_ALL; payload: unknown },
) => {
  const { type, payload } = action;

  switch (action.type) {
    case AddPropertyConstants.UPDATE_ALL:
      return { ...state, ...(payload as Record<string, unknown>) };
    default:
      return { ...state, [type]: payload };
  }
};

export default listing;
